import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "Store/configureStore";

export const organizationAddressStateSelector = (state: RootState) =>
  state.organizationAddress;

export const organizationAddressDataSelector = createSelector(
  organizationAddressStateSelector,
  (_: RootState, params: { organizationId: string }) => params,
  (orgAddressState, { organizationId }) =>
    orgAddressState?.data?.[organizationId] ?? {
      address: undefined,
      loadingGet: undefined,
      loadingUpdate: undefined,
      error: undefined
    }
);
